import { compose, withState, lifecycle, withHandlers } from "recompose";
import CreateSourceManual from "../libs/createSourceManual";
import GetPosts from "../libs/getInstagramPosts";

export const withEditTopNine = compose(
  withState("selectedPost", "updateSelectedPost", {}),
  withState("selectedGridBlockIndex", "updateSelectedGridBlock", 0),
  withState("newGridPosts", "updateNewGridPosts", new Array(9).fill({})),
  withState("loading", "setLoading", false),
  withHandlers({
    updateGridBlock: ({ selectedGridBlockIndex, newGridPosts, ...props }) => ({ post, index }) => {
      if (selectedGridBlockIndex || selectedGridBlockIndex === 0) {
        const newPosts = [...newGridPosts];
        newPosts[selectedGridBlockIndex] = { ...post, index };
        props.updateNewGridPosts(newPosts);
        props.updateSelectedPost({ id: newPosts.id, index });
      }
    },
    onClickContinue: props => () => {
      props.setLoading(true);
      const posts = props.newGridPosts
        .map(p => {
          const post = { ...p };
          delete post.index;
          delete post.__typename;
          return post;
        })
        .filter(p => p.id);
      if (posts.length > 0) {
        CreateSourceManual({ posts }).then(user => {
          props.setLoading(false);
          if (user.id) {
            window.location.href = `/best-2020/${user.sources[0].name}`;
          }
        });
      }
    },
  }),
  lifecycle({
    componentDidMount() {},
  })
);

export const withInstagramPosts = compose(
  withState("isFetching", "updateIsFetching", false),
  withState("afterCursor", "updateAfterCursor", null),
  withState("posts", "updatePost", []),
  withHandlers({
    getPosts: props => () => {
      props.updateIsFetching(true);
      GetPosts({ after: props.afterCursor }).then(instagramPosts => {
        if (instagramPosts.afterCursor) {
          props.updateAfterCursor(instagramPosts.afterCursor);
        }
        if (instagramPosts.posts && instagramPosts.posts.length > 0) {
          props.updatePost([...props.posts, ...instagramPosts.posts]);
        }
        props.updateIsFetching(false);
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getPosts();
    },
    componentWillReceiveProps(nextProps) {
      if (nextProps.afterCursor && nextProps.afterCursor !== this.props.afterCursor && !nextProps.isFetching) {
        getPosts();
      }
    },
  })
);
